import { endpointTripletex } from './base.config';

export const tripletexVoucherPurchase = {
  getVoucherPurchases:  `${endpointTripletex}/tripletex/voucher-purchases`,
  getVoucherPurchaseCount: `${endpointTripletex}/tripletex/voucher-purchases/count`,
  getVoucherPurchaseFromTripletex: `${endpointTripletex}/tripletex/voucher-purchases/from-tripletex`,
  getLedgerAccountFromTripletex: `${endpointTripletex}/tripletex/voucher-purchases/:companyId/ledger-account`,
  getLedgerVatTypeFromTripletex: `${endpointTripletex}/tripletex/voucher-purchases/:companyId/ledger-vat-type`,
  getSupplierFromTripletex: `${endpointTripletex}/tripletex/voucher-purchases/:companyId/supplier`,
  syncVoucherToPurchase: `${endpointTripletex}/tripletex/voucher-purchases/:companyId/sync-voucher`,
  syncVoucherPurchaseToTripletex: `${endpointTripletex}/tripletex/voucher-purchases/sync-tripletex`,
};
